import { RawChatUser } from "../Models/RawChatUser";


export class ChatUser
{
	public Id: string = "";
	public Name: string = "";

	constructor(raw?: Partial<RawChatUser>)
	{
		this.Id = raw?.Id || "";
		this.Name = raw?.Name || "";
	}

	public static Default = new ChatUser({ Name: "No user" });
}
